var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M40,21.875A3.244,3.244,0,0,1,36.667,25H3.333A3.244,3.244,0,0,1,0,21.875V3.125A3.244,3.244,0,0,1,3.333,0H36.667A3.244,3.244,0,0,1,40,3.125Z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M36.667,0H3.333A3.244,3.244,0,0,0,0,3.125v18.75A3.244,3.244,0,0,0,3.333,25H36.667A3.244,3.244,0,0,0,40,21.875V3.125A3.244,3.244,0,0,0,36.667,0Zm0,.625a2.59,2.59,0,0,1,2.667,2.5v18.75a2.59,2.59,0,0,1-2.667,2.5H3.333a2.59,2.59,0,0,1-2.667-2.5V3.125A2.59,2.59,0,0,1,3.333.625Z",
    fill: "none",
    opacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(8.6 9.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M40.291,18.979c-.173-.828-.343-1.642-.513-2.456l-.024,0-.891,2.458ZM36.2,21.339c.1-.247.2-.49.306-.733l2.26-5.4a.791.791,0,0,1,.792-.529q.659,0,1.317,0c.084,0,.121.017.141.109Q41.68,18,42.355,21.211c.009.042.014.085.021.133H40.787c-.06-.288-.124-.572-.176-.859-.019-.108-.062-.137-.169-.136-.652.006-1.306,0-1.958,0a.141.141,0,0,0-.161.113c-.091.269-.188.536-.29.8a.144.144,0,0,1-.1.081c-.562,0-1.124,0-1.686,0A.223.223,0,0,1,36.2,21.339Z",
    transform: "translate(-21.021 -14.553)",
    fill: "#152884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M33.69,14.782c-.1.467-.2.929-.3,1.395-.189-.063-.369-.132-.554-.183a2.694,2.694,0,0,0-1.243-.081,1.164,1.164,0,0,0-.431.181.415.415,0,0,0-.016.716,7.724,7.724,0,0,0,.663.411c.277.167.569.313.829.5a1.68,1.68,0,0,1,.657,1.948,2.173,2.173,0,0,1-1.429,1.457,4.414,4.414,0,0,1-1.974.226,4.973,4.973,0,0,1-1.24-.248c-.066-.023-.131-.05-.206-.079q.157-.735.308-1.441c.286.1.559.216.843.293a2.664,2.664,0,0,0,1.291.06,1.322,1.322,0,0,0,.479-.216.47.47,0,0,0,.036-.751,4.535,4.535,0,0,0-.608-.407c-.312-.193-.647-.352-.94-.57a1.7,1.7,0,0,1-.3-2.487,2.562,2.562,0,0,1,1.478-.9,4.427,4.427,0,0,1,2.555.137C33.625,14.755,33.654,14.767,33.69,14.782Z",
    transform: "translate(-18.115 -14.479)",
    fill: "#152884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M26.938,14.688c-.046.219-.089.434-.136.648q-.625,2.924-1.248,5.849c-.027.127-.07.17-.2.167-.471-.009-.941,0-1.412,0h-.146c.044-.209.086-.4.128-.6q.639-2.988,1.278-5.976c.013-.062.027-.1.1-.1.526,0,1.052,0,1.578,0C26.893,14.679,26.908,14.683,26.938,14.688Z",
    transform: "translate(-16.369 -14.552)",
    fill: "#152884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M11.952,14.677h2.869a.8.8,0,0,1,.868.719l.709,3.748a.432.432,0,0,0,.017.048c.026-.056.045-.094.061-.134q.844-2.131,1.684-4.263a.16.16,0,0,1,.18-.12c.514,0,1.029,0,1.542,0h.134c-.026.067-.045.121-.068.174q-1.339,3.2-2.677,6.392a.141.141,0,0,1-.154.107q-.807-.007-1.614,0c-.084,0-.113-.026-.134-.106-.453-1.759-.91-3.516-1.361-5.276a.807.807,0,0,0-.459-.565A7.771,7.771,0,0,0,12,14.888l-.086-.024c.006-.034.011-.064.017-.094S11.944,14.718,11.952,14.677Z",
    transform: "translate(-11.915 -14.552)",
    fill: "#152884"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.77eed8ae47e3ad21c04c0ce879484350.svg";
export { ForwardRef as ReactComponent };